<template>
  <!-- メールアドレス送信画面-->
  <CContainer class="d-flex flex-column justify-content-center min-vh-100" style="width:600px">
    <CRow>
      <CCol>
        <CCardGroup>
          <CCard class="p-4">
            <CCardBody>
              <ValidationObserver ref="obs" v-slot="ObserverProps">
                <CForm>
                  <h1>パスワード再設定</h1>
                  <p class="text-muted">
                    ご登録いただいたメールアドレス宛に
                    <br />パスワード変更ページのURLが記載されたメールを送信します。
                  </p>
                  <ul>
                    <li
                      style="color: red;"
                      v-for="error in errors"
                      :key="error.error_id"
                    >{{ '※' + error.error_name }}</li>
                  </ul>
                  <ValidationProvider
                    name="Email"
                    rules="required|email|max:254"
                    v-slot="ProviderProps"
                    mode="aggressive"
                  >
                    <CInput placeholder="Email" autocomplete="username email" v-model="email">
                      <template #prepend-content>
                        <CIcon name="cil-user" />
                      </template>
                    </CInput>
                    <p class="error">
                      <font color="red">{{ ProviderProps.errors[0] }}</font>
                    </p>
                  </ValidationProvider>
                  <CRow>
                    <CCol col="12">
                      <div>
                        <router-link to="Login">
                          <button class="btn btn-link px-0" type="button">戻る</button>
                        </router-link>
                        <save-button
                          :label="'送信'"
                          :loading="loading"
                          :disabled="!buttonFlg || ObserverProps.invalid || !ObserverProps.validated"
                          @click="sendMail"
                          class="btn btn-primary + px-4"
                        />
                      </div>
                    </CCol>
                  </CRow>
                </CForm>
              </ValidationObserver>
            </CCardBody>
          </CCard>
        </CCardGroup>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import axios from "axios";
import ConstList from "./../../ConstList";
import SaveButton from '../../common/SaveButton';
export default {
  name: "SendEmail",
  components: { SaveButton },
  data() {
    return {
      email: "",
      errors: [],
      buttonFlg: true,
      loading: false,
    };
  },
  methods: {
    // メール送信
    sendMail: function() {
      this.buttonFlg = false;
      this.loading = true;
      const item = {
        email: this.email
      };
      axios
        .post(process.env.VUE_APP_API_ORIGIN + "/send/mail", item)
        .then(response => {
          if (response.data === ConstList.SUCCESS) {
            this.$router.push({name: "ConfirmEmail", params: { email: this.email }});
            this.buttonFlg = true;
          } else {
            alert(ConstList.MAIL_ERROR);
            this.buttonFlg = true;
          }
        })
        .catch(error => {
          this.buttonFlg = true;
        axios
          .post(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError`,
            { error: String(error) },
            {
              headers: {
                'Content-Type': 'application/json'
              }
            }
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          })
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
}
/* ボタン2を右寄せにする */
button:nth-child(2) {
  float: right;
}
</style>

